// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';



const firebaseConfig = {
    apiKey: "AIzaSyCpJFf6bmB7lbm94pslWHttirt-LUtV9BM",
    authDomain: "eztrade-b70ba.firebaseapp.com",
    projectId: "eztrade-b70ba",
    storageBucket: "eztrade-b70ba.firebasestorage.app",
    messagingSenderId: "470153757578",
    appId: "1:470153757578:web:37a8b276c5156013edbe73",
    measurementId: "G-B83HWN8FXX"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
